import React from 'react';
import { Link } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Users, ArrowRight } from 'lucide-react';

const ServicesSection = ({ services = [], title = "Our Services", subtitle = "Expert care for all male sexual health and reproductive concerns", className = "" }) => {
    return (
        <section className={`py-16 ${className}`}>
            <div className="max-w-6xl mx-auto px-6">
                <div className="text-center mb-16">
                    <div className="inline-flex items-center bg-white/80 text-gray-800 px-5 py-2 rounded-full text-sm font-medium shadow-md mb-6 mx-auto backdrop-blur-sm border border-gray-200">
                        <Users className="h-4 w-4 mr-2" />
                        {title}
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                        Premium Healthcare Services
                    </h2>
                    <p className="text-base text-gray-600 max-w-2xl mx-auto leading-relaxed">
                        {subtitle}
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {services.slice(0, 6).map((service, index) => {
                        const IconComponent = LucideIcons[service.icon] || LucideIcons.Activity;
                        return (
                            <Card key={service.id || index} className="group hover:shadow-xl hover:-translate-y-2 transition-all duration-500 border-0 overflow-hidden bg-gradient-to-b from-white to-gray-50 hover:bg-white">
                                <div className="p-8 text-center">
                                    <div className="w-16 h-16 bg-gradient-to-br from-[#D91656]/10 to-[#1E5A8E]/10 rounded-2xl flex items-center justify-center mb-5 mx-auto group-hover:scale-105 transition-transform duration-500 shadow-lg">
                                        <IconComponent className="h-8 w-8 text-[#D91656] drop-shadow-sm" />
                                    </div>
                                    <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 group-hover:text-[#D91656] transition-colors">{service.title}</h3>
                                    <p className="text-gray-600 text-base leading-relaxed mb-6">{service.description}</p>
                                    <Button
                                        asChild
                                        className="w-full bg-white border-2 border-gray-200 hover:border-[#D91656] hover:bg-[#D91656]/5 text-gray-800 hover:text-[#D91656] shadow-md hover:shadow-lg transition-all duration-300 font-semibold px-6 py-4 rounded-xl"
                                    >
                                        <Link to="/treatments" className="flex items-center justify-center">
                                            Learn More
                                            <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                                        </Link>
                                    </Button>
                                </div>
                            </Card>
                        );
                    })}
                </div>

                <div className="text-center mt-20">
                    <Button asChild className="bg-[#1E5A8E] hover:bg-[#164A75] text-white shadow-xl hover:shadow-2xl px-12 py-6 text-xl font-bold rounded-2xl transition-all duration-300">
                        <Link to="/treatments">
                            Explore All Services
                        </Link>
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;
